import { cn } from '../../lib/utils.js';

// Range input styled to match the rest of the kit. Native <input
// type="range"> rather than a custom control so keyboard and screen
// readers work without extra wiring; the track/thumb are themed via
// vendor pseudo-elements in index.css.
export function Slider({
  id,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled,
  className,
  /** Rendered to the right of the track, e.g. "88 px". */
  valueLabel,
}: {
  id?: string;
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  valueLabel?: string;
}) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <input
        id={id}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
        className={cn(
          'ui-slider h-1.5 flex-1 cursor-pointer appearance-none rounded-full bg-muted',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
          disabled && 'cursor-not-allowed opacity-50',
        )}
      />
      {valueLabel && (
        <span className="w-14 shrink-0 text-right font-mono text-[11px] tabular-nums text-muted-foreground">
          {valueLabel}
        </span>
      )}
    </div>
  );
}
